'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.visibilityObserver = function () {
	const observer = new window.MutationObserver(function (mutations) {
			mutations.forEach(function (mutation) {
				const target = mmWidgets(mutation.target),
					wasHidden = mutation.oldValue && mutation.oldValue.indexOf('hidden') >= 0,
					isHidden = target.hasClass('hidden');
				if (wasHidden && !isHidden) {
					target.trigger('show');
				} else if (!wasHidden && isHidden) {
					target.trigger('hide');
				}
			});
		}),
		config = {attributes: true, attributeOldValue: true, attributeFilter: ['class']};

	this.domElements.forEach((element) => observer.observe(element, config));
	return this;
};
